import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnChanges, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from 'src/app/Core/services/data';
import { Moviesdb } from 'src/app/Core/services/dexiedb/moviedb.service';
import { LivestreamService } from 'src/app/Core/services/livestream.service';
import { MessageService } from 'src/app/Core/services/message.service';
import { MovieService } from 'src/app/Core/services/movie.service';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
import { SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';

@Component({
  selector: 'app-playlist-profile',
  templateUrl: './playlist-profile.component.html',
  styleUrls: ['./playlist-profile.component.css']
})
export class PlaylistProfileComponent implements OnInit,OnChanges,AfterViewChecked{
   @ViewChildren('pinInputRef') pinInputs!: QueryList<ElementRef>;
   private focused = false;
  playlist_id:any;
  profiles: any[] = [];
  states:any;
  categories:any;
  progress = 0;
  totalTasks = 6;
  loadingItems = [
  { label: 'Live TV', loaded: false, progress: 0 },
  { label: 'Movies', loaded: false, progress: 0 },
  { label: 'Series', loaded: false, progress: 0 }
];

overallProgress = 0;
currentLabel = '';
isLoadingdb:boolean = false;
isDeleteMode = false;
isEditMode= false;
selectedProfile: any = null;
showPinModal:boolean = false;
enteredPin = '';
pinError = false;
pinDigits = new Array(4);
enteredPinArray: string[] = ['', '', '', ''];

pendingEditId: string | null = null;
pinRedirectMode: 'edit' | 'login' | null = null;



  constructor(private seriesService:SeriesService,private moviesservice:MovieService,private livetvService:LivestreamService,private playlistService:PlaylistService,private router:Router,private route:ActivatedRoute,private messageService:MessageService,private utilService:UtilService){
    this.route.params.subscribe((res:any)=>{
      console.log(res);
      // this.playlist_id = res.id;
      
      
    })
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as {
      id: string;
      user_id: string;
      playlist_name: string;
      username:string;
      password: string;
      dns: string;
    };
  
    if (state) {
      this.playlist_id = state.id;
      console.log(this.playlist_id,'id=====');
      this.states = state;
      console.log('Received data:', state);
      
    }
  }

  ngOnInit(): void {
    this.getProfile()
  }
  ngAfterViewChecked(): void {
    if (this.showPinModal && !this.focused && this.pinInputs?.first) {
      this.focused = true;
      this.pinInputs.first.nativeElement.focus();
    }
  }

ngOnChanges() {
  this.focusFirstPinInput();
}
private focusFirstPinInput() {
  setTimeout(() => {
    if (this.showPinModal && this.pinInputs?.first) {
      this.pinInputs.first.nativeElement.focus();
    }
  });
}

  getProfile() {
    this.utilService.showSpinner()
    this.playlistService.getProfile().subscribe(
      (res:any) => {
        this.utilService.hideSpinner()
        console.log(res);
        if (res && res[this.playlist_id]) {
          this.profiles = res[this.playlist_id];
          console.log('Filtered Profiles:', this.profiles);
        } else {
          console.warn('No profiles found for playlist ID:', this.playlist_id);
          this.profiles = [];
        }
      },error =>{
      console.log(error);
      this.utilService.hideSpinner()
      }
    );
  }
  
  
  creteProfile(){
    this.router.navigate(['/create-profile'],{queryParams:{id:this.playlist_id},state:{id:this.states.id,playlist_name:this.states.playlist_name,username:this.states.username,password:this.states.password,dns:this.states.dns}})
  }


  //  editProfile(id:any){
  //   this.router.navigate(['/edit-profile'],{queryParams:{ids:id},state:{id:this.states.id,playlist_name:this.states.playlist_name,username:this.states.username,password:this.states.password,dns:this.states.dns}})
  // }
  editProfile(id: any) {
  const selected = this.profiles.find(p => p.profile.profile_id === id);

  if (selected?.profile?.pin) {
    // If PIN exists, open PIN modal first
    this.selectedProfile = selected.profile;
    this.showPinModal = true;

    // Prepare to redirect after PIN verification
    this.pendingEditId = id;
    this.pinRedirectMode = 'edit';
  } else {
    // No PIN, navigate directly
    this.navigateToEditProfile(id);
  }
}


navigateToEditProfile(id: any) {
  this.router.navigate(['/edit-profile'], {
    queryParams: { ids: id },
    state: {
      id: this.states.id,
      playlist_name: this.states.playlist_name,
      username: this.states.username,
      password: this.states.password,
      dns: this.states.dns
    }
  });
}




  async loginPlaylist(profile: any) {
  if (profile.pin) {
    this.selectedProfile = profile;
    this.showPinModal = true; // Use *ngIf or modal service
    return;
  }

  await this.continueLogin(profile);
}
async continueLogin(profile: any) {
  const movieCount = await Moviesdb.movies
    .where('playlist_id')
    .equals(profile.playlist_id)
    .count();

  const categoryCount = await Moviesdb.categories
    .where('playlist_id')
    .equals(profile.playlist_id)
    .count();

  if (movieCount > 0 || categoryCount > 0) {
    console.log(`Playlist ID ${profile.playlist_id} already exists in DB. Skipping loading modal.`);
    localStorage.setItem('isLocalPlaylist', 'false');
    localStorage.removeItem('localProfile');
    this.router.navigate(['/home']);
    return;
  }

  await this.saveDb(profile);
  this.router.navigate(['/home']);
}

 async loginPlaylists(profile:any){
  console.log(profile);
    if(profile.pin){
      console.log(profile.pin);
      return
    }
  
    // this.utilService.saveValueStorage(Constant.PLAYLIST_PROFILE,JSON.stringify(profile))
    // this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, this.states.user_id);
    // this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, this.states.username);
    // this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, this.states.password);
    // this.utilService.saveValueStorage(Constant.FULLURL_KEY,  this.states.dns);
    // const total = await this.livetvService.loadLivetv();
    // this.categories = await this.livetvService.loadLivetvCategories();
    // const totalmovies = await this.moviesservice.loadMovies();
    // const moviescategories = await this.moviesservice.loadCategories();
    // const seriesCategory = await this.seriesService.loadCategories();
    // const totalseries = await this.seriesService.loadSeries();
     const movieCount = await Moviesdb.movies
            .where('playlist_id')
            .equals(profile.playlist_id)
            .count();
    
          const categoryCount = await Moviesdb.categories
            .where('playlist_id')
            .equals(profile.playlist_id)
            .count();
    
          if (movieCount > 0 || categoryCount > 0) {
            console.log(`Playlist ID ${profile.playlist_id} already exists in DB. Skipping loading modal.`);
            localStorage.setItem('isLocalPlaylist','false');
            localStorage.removeItem('localProfile');
            this.router.navigate(['/home']);
            return;
          }
    await this.saveDb(profile)
    this.router.navigate(['/home']);
  }

   async saveDb(item){
    try {
          this.isLoadingdb = true;
          this.utilService.saveValueStorage(Constant.PLAYLIST_PROFILE,JSON.stringify(item))
          this.utilService.saveValueStorage(Constant.FULLUSERID_KEY,this.states.user_id);
          this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY,this.states.username);
          this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY,this.states.password);
          this.utilService.saveValueStorage(Constant.FULLURL_KEY,this.states.dns);
          // await this.livetvService.loadLivetv();
          // await this.livetvService.loadLivetvCategories();
          // await this.moviesService.loadMovies();
          // await this.moviesService.loadCategories();
          // await this.seriesService.loadCategories();
          // await this.seriesService.loadSeries();
          const totalItems = this.loadingItems.length;
          let completed = 0;

          // LIVE TV
          this.currentLabel = 'Loading Live TV categories...';
          await this.livetvService.loadLivetvCategories();
          this.currentLabel = 'Loading Live TV streams...';
          await this.livetvService.loadLivetv();
          this.markLoaded(0, ++completed, totalItems);

          // MOVIES
          this.currentLabel = 'Loading Movie categories...';
          await this.moviesservice.loadCategories();
          this.currentLabel = 'Loading Movies...';
          await this.moviesservice.loadMovies();
          this.markLoaded(1, ++completed, totalItems);

          // SERIES
          this.currentLabel = 'Loading Series categories...';
          await this.seriesService.loadCategories();
          this.currentLabel = 'Loading Series...';
          await this.seriesService.loadSeries();
          this.markLoaded(2, ++completed, totalItems);
          localStorage.setItem('isLocalPlaylist','false');
          localStorage.removeItem('localProfile');
          this.currentLabel = 'All content loaded!';
          this.router.navigate(['/home']);

        } catch (error) {
          console.error("Error loading data", error);
          this.isLoadingdb = false;
          localStorage.setItem('progressComplete','false')

        } finally {
          localStorage.setItem('progressComplete','true')
          this.isLoadingdb = false;
        }

  }
  markLoaded(index: number, completed: number, total: number) {
  this.loadingItems[index].loaded = true;
  this.loadingItems[index].progress = 100;
  this.overallProgress = Math.round((completed / total) * 100);
}

async wrapAndTrack(task: () => Promise<any>) {
  await task();
  this.progress += Math.round(100 / this.totalTasks);
  console.log(this.progress);
  
}

editMode() {
  if (this.isEditMode) {
    // Double-click: deactivate both
    this.isEditMode = false;
    this.isDeleteMode = false;
  } else {
    this.isEditMode = true;
    this.isDeleteMode = false;
  }
}

deleteMode() {
  if (this.isDeleteMode) {
    // Double-click: deactivate both
    this.isEditMode = false;
    this.isDeleteMode = false;
  } else {
    this.isEditMode = false;
    this.isDeleteMode = true;
  }
}


  deleteProfile(id){
    const confirmationTranslation = "Are sure want to Delete Profile ,all data will be deleted."
    const title = 'Delete Profile'
    this.messageService.confirm(title,confirmationTranslation).subscribe((answer:any)=>{
      if(answer === 'Yes'){
        this.playlistService.deleteProfiles(id).subscribe((res:any) =>{
          if(res){
            this.utilService.showSuccess(res.msg)
            this.getProfile()
          }
        })
      }
    })
    }
moveToNext(event: any, index: number) {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (!/^[0-9]$/.test(value)) {
    input.value = '';
    this.enteredPinArray[index] = '';
    return;
  }

  const nextInput = input.parentElement?.querySelectorAll('input')[index + 1];
  if (nextInput) {
    (nextInput as HTMLInputElement).focus();
  }
}

handleBackspace(event: KeyboardEvent, index: number) {
  if (event.key === 'Backspace' && !this.enteredPinArray[index] && index > 0) {
    const inputs = (event.target as HTMLInputElement).parentElement?.querySelectorAll('input');
    if (inputs && inputs[index - 1]) {
      (inputs[index - 1] as HTMLInputElement).focus();
    }
  }
}

verifyPin() {
  const enteredPin = this.enteredPinArray.join('');
  if (enteredPin === this.selectedProfile.pin) {
    this.showPinModal = false;
    this.enteredPinArray = ['', '', '', ''];
    this.pinError = false;
    this.focused = false;
    if(this.pinRedirectMode === 'edit'){
     this.navigateToEditProfile(this.pendingEditId);
    }else{
      this.continueLogin(this.selectedProfile);
    }
  } else {
    this.pinError = true;
  }
}

cancelPin() {
  this.showPinModal = false;
  this.enteredPinArray = ['', '', '', ''];
  this.pinError = false;
  this.selectedProfile = null;
  this.focused = false;
}
    


  handleImageError(event: any) {
    event.target.src = '/assets/images/new_login_flow/add-profile.png';
  }
  
}
